import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ring-bell",
  "use": "ring-bell-usage",
  "viewBox": "0 0 15 18",
  "content": "<symbol viewBox=\"0 0 15 18\" id=\"ring-bell\">\n    <g>\n      <path fill-rule=\"evenodd\" d=\"M1845.57,31.834a4.919,4.919,0,0,0-4.28-4.784V26.758a0.783,0.783,0,0,0-.63-0.763,0.773,0.773,0,0,0-.94.735v0.32a4.919,4.919,0,0,0-4.29,4.784c0,8.34-2.43,4.972-2.43,7.457a0.412,0.412,0,0,0,.42.4h14.16a0.412,0.412,0,0,0,.42-0.4V39.176C1848,37.031,1845.57,39.961,1845.57,31.834ZM1840.5,44a2.59,2.59,0,0,0,2.63-2.357h-5.25A2.573,2.573,0,0,0,1840.5,44Z\" transform=\"translate(-1833 -26)\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ring-bell.svg
// module id = null
// module chunks = 